import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) { navigate("/admin/login"); return; }
    (async () => {
      try {
        const res = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sid } });
        setUser({ ...res.data });
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: res.data } });
      } catch {
        navigate("/admin/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-luxe flex items-center justify-center">
      <p className="text-gold font-label text-sm animate-pulse">Signing you in…</p>
    </div>
  );
}
